"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WelcomeModal = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const react_i18next_1 = require("react-i18next");
const Modal_1 = require("./Modal");
const typography_1 = require("../../shared/typography");
const icons_1 = require("../../atoms/icons");
const buttons_1 = require("../../atoms/buttons");
const WelcomeModal = ({ onClose }) => {
    const { t } = (0, react_i18next_1.useTranslation)("md");
    return ((0, jsx_runtime_1.jsx)(Modal_1.Modal, { variant: "regular", title: (0, jsx_runtime_1.jsxs)(Title, { children: [(0, jsx_runtime_1.jsx)(typography_1.H2, { children: t("welcomeModal.title") }, void 0), (0, jsx_runtime_1.jsx)(icons_1.Icon, { shape: "rectangle", onClick: onClose, icon: ["far", "times"] }, void 0)] }, void 0), children: (0, jsx_runtime_1.jsxs)(Wrapper, { children: [(0, jsx_runtime_1.jsx)(typography_1.P, { children: t("welcomeModal.firstParagraph") }, void 0), (0, jsx_runtime_1.jsx)(typography_1.P, { children: t("welcomeModal.secondParagraph") }, void 0), (0, jsx_runtime_1.jsx)(buttons_1.Button, { variant: "primary", onClick: onClose, children: t("welcomeModal.button") }, void 0)] }, void 0) }, void 0));
};
exports.WelcomeModal = WelcomeModal;
const Title = styled_components_1.default.div `
  align-items: center;
  display: flex;
  justify-content: space-between;

  div:last-of-type {
    cursor: pointer;
  }

  @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
    align-items: flex-start;
  }
`;
const Wrapper = styled_components_1.default.div `
  margin-top: ${({ theme }) => theme.spacings.m};

  & p {
    color: ${({ theme }) => theme.colors.greyBase};
  }

  p:first-of-type {
    margin-bottom: ${({ theme }) => theme.spacings.xl};
  }

  p:last-of-type {
    margin-bottom: ${({ theme }) => theme.spacings.m};
  }
`;
//# sourceMappingURL=Welcome.js.map